import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);


export default new Vuex.Store({
	state: {
		navigation: {
			sidebar: false
		},
		dialogcollege: {
			dialog: false
		},
		language: {
			cards: {
				cardtype: {
					business: "Businesscard",
				}
			},
			date: {
				today: 'vandaag',
				monday: "maandag",

			}
		}
	},
	mutations: {
		togglesidebar(state) {
			state.navigation.sidebar = !state.navigation.sidebar
		},
		togglecollegedialog(state) {
			state.dialogcollege.dialog = !state.dialogcollege.dialog
		},
	},
	actions: {
		togglesidebar({
			commit
		}) {
			commit('togglesidebar')
		},

		togglecollegedialog({
			commit
		}) {
			commit('togglecollegedialog')
		},
	},
	modules: {},
	getters: {
		getnavigation(state) {
			return state.navigation
		},

		getdialogcollege(state) {
			return state.dialogcollege
		},
		getlanguage(state) {
			return state.language
		}
	}
})